import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../api/client';

/**
 * OAuth callback handler for Supabase authentication.
 *
 * This page handles the redirect from OAuth providers (Google).
 * Supabase automatically processes the URL hash/params and establishes the session.
 * We check onboarding status and redirect accordingly.
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { user, loading, getToken } = useAuth();
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    async function checkOnboardingAndRedirect() {
      if (checking) return;
      setChecking(true);

      try {
        const token = getToken();

        if (!token) {
          setChecking(false);
          return;
        }

        const data = await api.get('/api/onboarding/status', {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (data.completed) {
          navigate('/dashboard', { replace: true });
        } else {
          navigate('/onboarding', { replace: true });
        }
      } catch (error) {
        // On error, redirect to onboarding to ensure user can complete setup
        navigate('/onboarding', { replace: true });
      }
    }

    if (!loading) {
      if (user) {
        checkOnboardingAndRedirect();
      } else {
        navigate('/login', { replace: true });
      }
    }
  }, [user, loading, navigate, getToken, checking]);

  return (
    <div style={{
      minHeight: '100vh',
      background: 'var(--bg-base)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'var(--text-primary)'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          width: '48px',
          height: '48px',
          border: '3px solid var(--border-subtle)',
          borderTop: '3px solid var(--indigo-500)',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 16px'
        }} />
        <p style={{ color: 'var(--text-tertiary)' }}>Completing sign in...</p>
      </div>
    </div>
  );
}
